/*
 * @Author: 周立伟 1508761480@qq.com
 * @Date: 2022-09-08 15:34:59
 * @LastEditors: 周立伟 1508761480@qq.com
 * @LastEditTime: 2022-09-27 10:37:11
 * @FilePath: \login\modes\src\App.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React ,{Suspense}from "react";

// import { useRoutes } from "react-router-dom";
import Router from "./router";
import "./App.css";
// import "react-vant/es/styles";

function App() {
  // const element = useRoutes(RouterList);
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Router>
      {/* <div className="App"></div> */}
      </Router>
    </Suspense>
   
  )
}

export default App;
